import React, { useState } from 'react';
import {
	Box,
	TextField,
	Typography,
	List,
	ListItem,
	FormControlLabel,
	Switch,
	InputAdornment,
	Tooltip,
	Chip,
	ListItemText,
	ClickAwayListener,
	Popper,
	Grow,
	Paper,
	Avatar,
	Collapse,
	Slider,
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import '../../../../styles/pages/admin/settings/default-okr/createDefaultOkrCard.scss';
import { OKRButton } from '../../../Common/OKRButton';
import { Enums } from '../../../../config/enums';
import { DeleteIcon, SearchIcon } from '../../../../config/svg/CommonSvg';
import { CalendarIcon, CrossIcon, PublishedOnIcon, SortingIcon } from '../../../../config/svg/CommonSvgIcon';
import { SettingsIcon } from '../../../../config/svg/MyGoalSvg';
import { getCurrencyIcon, getCurrencyName, getMonthDate, getUserName } from '../../../../config/utils';
import { ErrorIcon } from '../../../../config/svg/formElementIcons';
import { LeftArrow, RightArrow } from '../../../../config/svg/ArrowSvg';
import { useDispatch, useSelector } from 'react-redux';
import { KpiCategoryNameDropdown } from './KpiCategoryNameDropdown';
import { getDefaultKpiCategories } from '../../../../action/adminDefaultOkr';
import { OkrProgressBar } from '../../../OkrAction/OkrProgressBar';
import { ProgressBar } from './ProgressBar';
import { KpiActions } from '../KpiActions';

export const CreateDefaultKpiDetails = (props: any) => {
	const {
		defaultOkrFormDetails,
		setDefaultOkrFormDetails,
		handleObjectiveNameChange,
		handleKrNameChange,
		handleKrProgressChange,
		handleKrDrawerOpen,
		handleOkrDeletionClick,
		handleKRDeletionClick,
		selectedCycleDetails,
		handleDraftDefaultOkrClick,
		handleSaveAndPublishLaterDefaultOkrClick,
		handlePublishDefaultOkrClick,
		okrNameError,
		showLoader,
		handleIsWeightSameToggleClick,
		handleIsTargetSameToggleClick,
		handleKrStartTargetValueChange,
		handleKrRoleStartTargetValueChange,
		handleWeightUpdate,
		handleKrRoleSearch,
		handleKrRoleSort,
		handleKrExpandCollapse,
		weightSelectionOpen,
		setWeightSelectionOpen,
		handleDrawerOpen,
		okrRoleError,
		setOkrNameError,
	} = props;
	const { t } = useTranslation();
	const dispatch = useDispatch();
	const { okrMasterData } = useSelector((state: any) => state.okrReducer);

	const [sortOrder, setSortOrder] = useState<string>('asc');
	const [sortingColumn, setSortingColumn] = useState<string>('');
	// const [weightSelectionOpen, setWeightSelectionOpen] = useState<boolean>(false);
	const [anchorEl, setAnchorEl] = useState<any>(null);
	const [selectedWeightDetails, setSelectedWeightDetails] = useState<any>({
		details: null,
		type: '',
	});
	// Organization default category
	const [categories, setCategories] = useState<any>([]);
	const [openCategory, setOpenCategory] = useState<boolean>(false);
	const [selectedCategory, setSelectedCategory] = useState<string | null>(null);
	const [selectedCategoryData, setSelectedCategoryData] = useState<any>({});
	const [isFieldEnabled, setIsFieldEnabled] = useState<boolean>(false);

	const handleClick = () => {
		setOpenCategory((prev) => !prev);
	};

	const handleClickAway = () => {
		setOpenCategory(false);
	};
	const handleCategorySelect = (category: any) => {
		setSelectedCategory(category.name);
		setSelectedCategoryData(category);
		setOkrNameError({ error: false, errorText: '' });
		setDefaultOkrFormDetails &&
			setDefaultOkrFormDetails({
				...defaultOkrFormDetails,
				kpiCategoryMasterId: category.kpiCategoryMasterId,
				objectiveName: category.name,
				name: category.name,
			});
		setIsFieldEnabled(true);
		handleClickAway();
	};

	const handleCollapse = (e: any, krItem: any, krIndex: number) => {
		// setCollapse((prev) => !prev);
		handleKrExpandCollapse(krItem, krIndex);
	};
	const handleWeightClick = (e: any, krItem: any, krIndex: number) => {
		setAnchorEl(e.currentTarget);
		setWeightSelectionOpen(true);
		setSelectedWeightDetails({
			details: {
				krItem,
				krIndex,
			},
			type: 'KrWeight',
		});
	};
	const handleWeightClose = () => {
		setWeightSelectionOpen(false);
		setAnchorEl(null);
	};
	const handleRoleWeightClick = (e: any, krItem: any, krIndex: number, role: any, roleIndex: number) => {
		setAnchorEl(e.currentTarget);
		setWeightSelectionOpen(true);
		setSelectedWeightDetails({
			details: {
				krItem,
				krIndex,
				role,
				roleIndex,
			},
			type: 'KrRoleWeight',
		});
	};
	const handleWeightSelection = (e: any, weight: number) => {
		// console.log(weight, selectedWeightDetails);
		handleWeightUpdate(selectedWeightDetails, weight);
		handleWeightClose();
	};
	const getWeightName = (details: any) => {
		const roleName = details?.weight ? details?.weight + 'x' : '1x';

		return roleName || '';
	};

	const handleSearchClicked = (e: any, krItem: any, krIndex: number) => {
		const { value } = e?.target || {};
		handleKrRoleSearch(value, 'insert', krItem, krIndex);
	};
	const searchClicked = (e: any, krItem: any, krIndex: number) => {
		if (e.key === 'Enter') {
			const { value } = e?.target || {};
			if (value && value.trim() !== '') {
				handleKrRoleSearch(value, 'search', krItem, krIndex);
			} else {
				handleKrRoleSearch('', 'search', krItem, krIndex);
			}
		}
	};
	const clearSearch = (e: any, krItem: any, krIndex: number) => {
		handleKrRoleSearch('', 'clear', krItem, krIndex);
	};

	const sortUserList = (e: any, column: any, roleList: any, krItem: any, krIndex: any) => {
		let newSortOrder = 'desc';
		if (column === sortingColumn) {
			setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
			newSortOrder = sortOrder === 'asc' ? 'desc' : 'asc';
		} else {
			setSortOrder('desc');
		}
		if (column === 'targetValue') {
			roleList = roleList?.map((role: any) => {
				role.startTargetDiff = role.targetValue - role.startValue;
				return role;
			});
		}
		let updatedRoleList = sortArrayByKey(roleList, column === 'targetValue' ? 'startTargetDiff' : column, newSortOrder);
		if (column === 'targetValue') {
			updatedRoleList = updatedRoleList?.map((role: any) => {
				delete role.startTargetDiff;
				return role;
			});
		}
		updatedRoleList = dataPerPage(updatedRoleList, 1, Enums.MAX_USER_SIZE);
		setSortingColumn(column);
		// console.log(updatedRoleList);
		handleKrRoleSort(column, updatedRoleList, krItem, krIndex);
		// setLocalRoleList(updatedRoleList);
		// resetCheckState();
	};
	const sortArrayByKey = (arrayList: any, keyName: string, sortingType: string) => {
		arrayList.sort(function (a: any, b: any) {
			const keyA = a[keyName];
			const keyB = b[keyName];
			if (sortingType === 'asc') {
				if (keyA < keyB) return -1;
				if (keyA > keyB) return 1;
			} else if (sortingType === 'desc') {
				if (keyA > keyB) return -1;
				if (keyA < keyB) return 1;
			}
			return 0;
		});

		return arrayList;
	};
	const dataPerPage = (arrayList: any, currPage: any, pageSizeValue: any) => {
		const startIndex = currPage - 1;
		const updatedList = arrayList.slice(startIndex * pageSizeValue, pageSizeValue * currPage);

		return updatedList;
	};
	const getQuarterDetails = () => {
		const { symbol, year } = selectedCycleDetails || {};

		return symbol && year ? `(${symbol}, ${year})` : '';
	};
	const checkKrDIsable = () => {
		return !defaultOkrFormDetails?.keyDescription || defaultOkrFormDetails?.keyDescription?.trim() === ''
			? true
			: false;
	};
	const getFilteredList = (fullRoleList: any, searchText: string) => {
		if (searchText) {
			return fullRoleList?.filter((rr: any) => rr?.keyDescription?.toLowerCase().includes(searchText?.toLowerCase()));
		} else {
			return fullRoleList;
		}
	};
	// console.log('CreateDefaultOkrDetails ==> ', defaultOkrFormDetails);

	const fetchKpiCategories = async () => {
		try {
			const response: any = await dispatch(getDefaultKpiCategories());
			if (response) {
				if (response.data && response.data.status === 200) {
					const { entity } = response.data;
					setCategories(entity);
				} else {
					setCategories([]);
				}
			}
		} catch (e) {
			console.error(e);
		}
	};

	return (
		<>
			{/* {defaultOkrFormDetails?.assignType === Enums.ZERO ? (
				<> Let's add an objective</>
			) : ( */}
			<Box className='create-default-okr-card'>
				<Box className='create-default-okr-card-inner'>
					<Box className='create-default-obj'>
						{/* <TextField
							className='add-objective helperText-bottom'
							id='create-default-obj-field'
							multiline
							autoFocus={true}
							maxRows={2}
							placeholder={t('addAnObjective')}
							InputProps={{ 'aria-label': t('addDefaultObj'), disableUnderline: true }}
							name={'name'}
							value={defaultOkrFormDetails?.keyDescription || ''}
							onChange={handleObjectiveNameChange}
							error={okrNameError?.error}
							helperText={
								okrNameError?.error && okrNameError?.errorText ? (
									<>
										<ErrorIcon />
										{okrNameError?.errorText}
									</>
								) : (
									''
								)
							}
						/> */}
						<KpiCategoryNameDropdown
							fetchKpiCategories={fetchKpiCategories}
							categories={categories}
							openCategory={openCategory}
							selectedCategory={selectedCategory}
							handleClick={handleClick}
							handleClickAway={handleClickAway}
							handleCategorySelect={handleCategorySelect}
							okrNameError={okrNameError}
						/>
						{isFieldEnabled && (
							<Box className='default-okr-field-actions'>
								<OKRButton
									className='delete-btn'
									id='objective-delete-btn'
									icon={<DeleteIcon />}
									text={t('delete')}
									title={t('delete')}
									handleClick={(e: any) => handleOkrDeletionClick(e, defaultOkrFormDetails)}
								/>
							</Box>
						)}
					</Box>
					{defaultOkrFormDetails?.myGoalsDetails && defaultOkrFormDetails?.myGoalsDetails.length ? (
						defaultOkrFormDetails?.myGoalsDetails.map((krItem: any, krIndex: number) => {
							return (
								<Box className='create-default-kr'>
									<Box className='create-default-kr-inner'>
										<Box className='create-default-kr-head'>
											<Box className='create-default-kr-head-inner'>
												<TextField
													className='add-kr helperText-bottom'
													id={`create_default_kr_field_index_${krIndex}`}
													multiline
													maxRows={2}
													placeholder={t('letsAddKpi')}
													InputProps={{ 'aria-label': t('addDefaultKr'), disableUnderline: true }}
													// disabled={checkKrDIsable()}
													disabled={!isFieldEnabled}
													value={krItem?.keyDescription || ''}
													onChange={(event) => handleKrNameChange(event, krItem, krIndex)}
													error={krItem?.isKrNameError}
													helperText={
														krItem?.isKrNameError && krItem?.krNameErrorMsg ? (
															<>
																<ErrorIcon />
																{krItem?.krNameErrorMsg}
															</>
														) : (
															''
														)
													}
												/>
												{krItem?.keyDescription && krItem?.keyDescription?.trim() !== '' ? (
													<ProgressBar
														scoreValue={krItem.scoreValue}
														dueDate={krItem.dueDate}
														handleSliderChange={(e: any, val: any) => {
															handleKrProgressChange(e, krItem, krIndex, val);
															console.log(val);
														}}
													/>
												) : (
													<></>
												)}
											</Box>
											{krItem?.keyDescription && krItem?.keyDescription?.trim() !== '' ? (
												<Box className='default-okr-field-actions'>
													{krItem?.publishedOn ? (
														<Box className='set-timeline-area'>
															<Box className='timeline-field'>
																<Box className='calendar-btn'>
																	<OKRButton
																		title={t('publishedOn')}
																		text={
																			krItem?.publishedOn
																				? `${getMonthDate(krItem?.publishedOn)} ${getQuarterDetails()}`
																				: ''
																		}
																		icon={<PublishedOnIcon />}
																		buttonType={'disableButtonTooltip'}
																		disabled={true}
																	/>
																</Box>
															</Box>
														</Box>
													) : (
														<></>
													)}

													<KpiActions
														keyDetails={krItem}
														krIndex={krIndex}
														showLoader={showLoader}
														mode={'Add'}
														defaultOkrFormDetails={defaultOkrFormDetails}
														setDefaultOkrFormDetails={setDefaultOkrFormDetails}
													/>
													{/*<OKRButton
														className={`settings-btn ${
															krItem?.isMetricTypeError || krItem?.isMetricCurrencyError ? 'settings-btn-error' : ''
														}`}
														id='default-obj-setting-btn'
														icon={<SettingsIcon />}
														disabled={!isFieldEnabled}
														handleClick={(e) => {
															handleKrDrawerOpen(e, krItem, krIndex);
														}}
														text={t('attributesLabel')}
														title={t('okrHoverText')}
														tooltipClassName={`tooltip-layout3 ${
															krItem?.isMetricTypeError || krItem?.isMetricCurrencyError ? 'tooltip-error-new' : ''
														}`}
													/>
													<OKRButton
														className='delete-btn'
														id='objective-delete-btn'
														icon={<DeleteIcon />}
														text={t('delete')}
														title={t('delete')}
														disabled={!isFieldEnabled}
														handleClick={(e) => handleKRDeletionClick(e, krItem, krIndex)}
													/>*/}
												</Box>
											) : (
												<></>
											)}
										</Box>
									</Box>
								</Box>
							);
						})
					) : (
						<></>
					)}
					<Box className='create-deafult-okr-actions'>
						{defaultOkrFormDetails?.status === Enums.TWO ||
						defaultOkrFormDetails?.status === Enums.THREE ||
						defaultOkrFormDetails?.status === Enums.FOUR ? (
							<></>
						) : (
							<OKRButton
								className='btn-link'
								id='save-as-draft'
								text={t('saveAsDraft')}
								//disabled={showLoader}
								handleClick={handleDraftDefaultOkrClick}
							/>
						)}
						<OKRButton
							className='btn-primary'
							id='default-obj-save-btn'
							text={t('submitKpi')}
							//disabled={showLoader}
							handleClick={handlePublishDefaultOkrClick}
						/>
					</Box>
				</Box>
			</Box>
			{/* )} */}

			{weightSelectionOpen && (
				<Popper
					className='popper-menu weightage-dropdown'
					open={weightSelectionOpen}
					anchorEl={anchorEl}
					placement='bottom'
					transition
					modifiers={{
						preventOverflow: {
							enabled: false,
							boundariesElement: window,
						},

						flip: {
							enabled: false, // true by default
						},
					}}
				>
					{({ TransitionProps }) => (
						<Paper>
							<ClickAwayListener onClickAway={handleWeightClose}>
								<List component='div' disablePadding>
									<ListItem
										className='active'
										component='div'
										id={`assign-weightage-1`}
										onClick={(e) => handleWeightSelection(e, 1)}
									>
										<ListItemText>1x</ListItemText>
									</ListItem>
									<ListItem component='div' id={`assign-weightage-2`} onClick={(e) => handleWeightSelection(e, 2)}>
										<ListItemText>2x</ListItemText>
									</ListItem>
									<ListItem component='div' id={`assign-weightage-3`} onClick={(e) => handleWeightSelection(e, 3)}>
										<ListItemText>3x</ListItemText>
									</ListItem>
									<ListItem component='div' id={`assign-weightage-4`} onClick={(e) => handleWeightSelection(e, 4)}>
										<ListItemText>4x</ListItemText>
									</ListItem>
									<ListItem component='div' id={`assign-weightage-5`} onClick={(e) => handleWeightSelection(e, 5)}>
										<ListItemText>5x</ListItemText>
									</ListItem>
								</List>
							</ClickAwayListener>
						</Paper>
					)}
				</Popper>
			)}
		</>
	);
};
